import {
  BEACON_EXPERIMENT_NAME,
  BEST_MATCH_BANNER_EXPERIMENT_NAME,
  BROWSE_SKU_CARD_EXPERIMENT_NAME,
} from '@/constants/global';

const initialState = () => ({
  [BEACON_EXPERIMENT_NAME]: false,
  [BEST_MATCH_BANNER_EXPERIMENT_NAME]: 'disabled',
  [BROWSE_SKU_CARD_EXPERIMENT_NAME]: 'disabled',
});

export { initialState as state };

export const getters = {
  getExperimentVariant: (state) => (experimentKey) => (
    state?.[experimentKey]
  ),
};

export const mutations = {
  set(state, data) {
    Object.keys(data).forEach((key) => {
      state[key] = data[key]; // eslint-disable-line no-param-reassign
    });
  },
};

export const actions = {
  async enroll({ commit }) {
    const enrollBeacon = async () => await this.$experiments.enroll(BEACON_EXPERIMENT_NAME) === 'enabled';
    const enrollSKUCard = async () => this.$experiments.enroll(BROWSE_SKU_CARD_EXPERIMENT_NAME);
    const enrollBestMatchBanner = async () => (
      this.$experiments.enroll(BEST_MATCH_BANNER_EXPERIMENT_NAME)
    );
    // add any more global campaigns here
    const [beaconValue, skuValue, bestMatchValue] = await Promise.all([
      enrollBeacon(),
      enrollSKUCard(),
      enrollBestMatchBanner(),
    ]);
    commit('set', {
      [BEACON_EXPERIMENT_NAME]: beaconValue,
      [BROWSE_SKU_CARD_EXPERIMENT_NAME]: skuValue,
      [BEST_MATCH_BANNER_EXPERIMENT_NAME]: bestMatchValue,
    });
  },
};
